import { get } from "sites-common/utils/lodash";
import {
  queryPatients,
  patientsConfig,
  postprocessPatients,
  patientsSelectors,
  validatePatients,
} from "../../common1/firebase-selectors/patients";
import { RenderColumns, excelColumns } from "./renderItemCard";
import { patientsCareAppUrl, homeCareAppUrl } from "../../care-app/urls";

const Config = (i_am_admin = false, trainerOpts = [], trainersMap = {}) => {
  const pSelectors = patientsSelectors();

  return {
    primaryKey: patientsConfig.primaryKey,

    disableEditPrimaryKey: true,

    initialQueries: [queryPatients()],

    homeUrl: patientsCareAppUrl,
    backUrl: homeCareAppUrl,

    sessionKey: "careapp.patients.all",
    noItemMsg: "No Patients Loaded",
    mainTitle: "All Patients",
    mainTitleIcon: "Group",

    pageOptions: {
      Status: {
        optionsSelector: pSelectors.valuesGivenKey("status"),
        pageSelector: pSelectors.listGivenKV("status"),
      },
      "All Patients": {
        optionsSelector: () => [{ key: "all", text: "All Patients" }],
        pageSelector: pSelectors.ordered,
      },
    },

    singleItemSelector: pSelectors.id,
    singleItemDispatcher: null,

    collection: patientsConfig.collection,
    postprocess: postprocessPatients,
    validate: validatePatients,
    formFields: patientsConfig.fields(true, true, trainerOpts, true),
    formDefaults: patientsConfig.defaults,
    autogenPrimaryKey: true,

    editBtnText: "View / Edit Details",
    newBtnText: i_am_admin ? "New" : null,
    panelForNewItem: true,
    panelForEditItem: true,
    editContainerProps: {
      style: { maxWidth: 350 },
    },

    renderItemCard: null,
    colDefns: RenderColumns(patientsConfig.primaryKey, trainersMap),
    showTableHeader: true,
    displayAsTable: true,
    tableEditButtonProps: i_am_admin ? { text: "Edit" } : null,

    excelColDefns: excelColumns(patientsConfig.primaryKey, trainersMap),

    filterProps: {
      placeholder: "Patient / City / Trainer",
      searchFunction: (r) =>
        `${JSON.stringify(r.caretrainers) + r.name} ${r.city} ${r.email} ${
          r.country
        } ${r.state}`,
      filterMenuItems: [
        {
          key: "name",
          text: "Name (Ascending)",
          f: (a, b) => a.name.toLowerCase() > b.name.toLowerCase(),
        },
        {
          key: "city",
          text: "City (Ascending)",
          f: (a, b) => a.city.toLowerCase() > b.city.toLowerCase(),
        },
        {
          key: "city_d",
          text: "City (Descending)",
          f: (a, b) => a.city.toLowerCase() < b.city.toLowerCase(),
        },
        {
          key: "country",
          text: "Country/State (Ascending)",
          f: (a, b) =>
            (get(a, "country", "") + get(a, "state", "")).toLowerCase() >
            (get(b, "country", "") + get(b, "state", "")).toLowerCase(),
        },
        {
          key: "d4",
          text: "New Patients",
          f: (a, b) => a.added_on > b.added_on,
          sf: (r) => !r.last_sitting_date,
        },
        {
          key: "d5",
          text: "Days Since Last Sitting",
          f: (a, b) => a.last_sitting_days <= b.last_sitting_days,
          sf: (r) => {
            return !!r.last_sitting_date;
          },
        },
      ],
    },
  };
};
export default Config;
